import personasImage from "../../../media/img/home/details/personas.png";
import toolsImage from "../../../media/img/home/details/tools.png";
import chatImage from "../../../media/img/home/details/chat.png";
import settingImage from "../../../media/img/home/details/setting.png";
import youtubeImage from "../../../media/img/home/details/youtube.png";

const Details = () => {
  const detailCards = [
    {
      id: 1,
      title: "Personas",
      description:
        "Create and customize AI personas tailored to your specific needs. Switch between different personalities and expertise areas for specialized conversations and enhanced productivity.",
      image: personasImage,
    },
    {
      id: 2,
      title: "Tools",
      description:
        "Access powerful AI-driven tools including web search, image generation, code writing, and YouTube summarization. Enhance your workflow with integrated productivity features.",
      image: toolsImage,
    },
    {
      id: 3,
      title: "Chat",
      description:
        "Experience natural, intelligent conversations with advanced AI models. Get instant responses, creative assistance, and detailed explanations on any topic you need help with.",
      image: chatImage,
    },
    {
      id: 4,
      title: "Model Setting",
      description:
        "Fine-tune AI model parameters including temperature, output length, and system instructions. Customize the AI's behavior to match your specific requirements and preferences.",
      image: settingImage,
    },
    {
      id: 5,
      title: "YouTube Recap",
      description:
        "Transform YouTube videos into comprehensive summaries and transcripts. Choose from different summary types, languages, and tones to get exactly what you need.",
      image: youtubeImage,
    },
  ];

  return (
    <section className="py-20 bg-bg-70">
      <div className="w-[90%] max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-4">
            <span className="text-fg-60">Get your future AI</span>{" "}
            <span className="text-fg-40">detail</span>
            <br />
            <span className="text-fg-40">overview</span>
          </h1>
        </div>

        {/* Details Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {/* First Row - 3 cards */}
          {detailCards.slice(0, 3).map((card) => (
            <div
              key={card.id}
              className="bg-bg-70 rounded-2xl border border-bd-50 overflow-hidden transition-all duration-300"
            >
              {/* Card Image - No padding */}
              <div className="bg-bg-50  py-2">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-48 object-cover"
                  draggable="false"
                />
              </div>

              {/* Card Content */}
              <div className="p-6">
                <h3 className="text-lg font-semibold text-fg-40 mb-3">
                  {card.title}
                </h3>
                <p className="text-fg-60 text-sm leading-relaxed">
                  {card.description}
                </p>
              </div>
            </div>
          ))}

          {/* Second Row - 2 cards taking remaining space */}
          <div className="md:col-span-2 lg:col-span-3">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {detailCards.slice(3, 5).map((card) => (
                <div
                  key={card.id}
                  className="bg-bg-70 rounded-2xl border border-bd-50 overflow-hidden transition-all duration-300"
                >
                  {/* Card Image - No padding */}
                  <div className="bg-bg-50">
                    <img
                      src={card.image}
                      alt={card.title}
                      className="w-full h-48 object-cover"
                      draggable="false"
                    />
                  </div>

                  {/* Card Content */}
                  <div className="p-6">
                    <h3 className="text-lg font-semibold text-fg-40 mb-3">
                      {card.title}
                    </h3>
                    <p className="text-fg-60 text-sm leading-relaxed">
                      {card.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Details;
